/* POTŘEBA RENTY Z DAT ANALÝZY — JEDNA FUNKCE PRO CELOU APPKU (5. 10. 2026)
 * ============================================================================
 * Majitel v dotazníku 5. 10. 2026 („Ano, počítat bez nich“, nález M1-15
 * a náhled kina 50/30/20): renta nemá platit to, co v důchodu platit nebudete.
 *
 *   potřeba = výdaje
 *           − vlastní pravidelné vklady na spoření (stavebko, penzijko, fondy,
 *             KŽP, spořicí účty; BEZ příspěvku zaměstnavatele — ten z příjmu
 *             domácnosti neodchází, ve výdajích tedy není)
 *           + splátky úvěrů, které běží i v rentě nebo u nich konec spočítat
 *             nejde (chybí úrok / zůstatek — opatrně se počítají dál)
 *
 * Úvěr doplacený před začátkem renty (podle data konce, jinak odhad z jistiny,
 * úroku a splátky) se nepočítá. Výpočet je v doporuceniCile.js
 * (`rentaSeZavazky`), tady se jen skládají vstupy z dat — TÝMIŽ funkcemi jako
 * lišta, kina a plán (lib/bilance.js).
 *
 * KDO TO VOLÁ (každé místo, kde se potřeba renty počítá z výdajů):
 *   · panel „Cíl renty vs. výdaje“ a nápověda u cíle renty
 *     (doporuceniZAnalyzy.js → `rentaZAnalyzy`, AnalyzaV2Page → CilHint),
 *   · kino 50/30/20 v analýze (dějství Rentiér) a kino u cíle renty,
 *   · plán (planEngine): renta bez zadaného cíle — jen plán s razítkem
 *     metodiky ≥ 2026-10-05; starší uložený plán drží „renta = výdaje“.
 * Analýza platí hned (není to uložený plán).
 *
 * Modul je malý schválně: planEngine ho načítá bez celé vrstvy textů
 * doporuceniZAnalyzy (slovníky pěti jazyků).
 */
import { asArr, asObj } from "../bezpecneHodnoty";
import { volneCashflow, pravidelneVklady, prispevekZamestnavatele } from "../bilance";
import { rentaSeZavazky } from "./doporuceniCile";

/* Datum ISO („2026-10-03“) → Date, jinak null. */
const datumZDat = (v) => {
  if (typeof v !== "string" || !/^\d{4}-\d{2}-\d{2}/.test(v.trim())) return null;
  const t = Date.parse(v.trim().slice(0, 10));
  return Number.isFinite(t) ? new Date(t) : null;
};

/**
 * Vlastní pravidelné vklady na spoření měsíčně — všechny vklady
 * (`pravidelneVklady`) bez příspěvku zaměstnavatele, nejméně 0.
 * @param {object} d data analýzy (v2)
 */
export function vlastniVkladyNaSporeni(d = {}) {
  const data = asObj(d);
  return Math.max(0, pravidelneVklady(data) - prispevekZamestnavatele(data));
}

/**
 * POTŘEBA RENTY Z DAT ANALÝZY.
 * @param {object} d data analýzy (v2)
 * @param {object} [volby]
 * @param {object} [volby.cil]  cíl renty; bez něj první cíl s `mesicne === true`
 * @param {number|string|null} [volby.rokyDoRenty] za kolik let renta začne;
 *   bez něj roky cíle renty (prázdno = neznámo → úvěry zůstávají v rentě)
 * @param {Date} [volby.dnes] datum, když analýza nemá `datum`
 * @returns {ReturnType<typeof rentaSeZavazky>} null = výdaje ani splátky nejsou zadané
 */
export function potrebaRenty(d = {}, volby = {}) {
  const data = asObj(d);
  const o = asObj(volby);
  const tok = volneCashflow(data);
  const c = o.cil || asArr(data.cile).find((x) => x?.mesicne === true) || null;
  const roky = Object.prototype.hasOwnProperty.call(o, "rokyDoRenty") ? o.rokyDoRenty : (c ? c.roky : null);
  return rentaSeZavazky({
    vydajeCelkem: tok.vydaje,
    vlastniVklady: vlastniVkladyNaSporeni(data),
    prijem: tok.prijmy,
    zavazky: [...asArr(data.zavazkyB), ...asArr(data.zavazkyO)],
    rokyDoRenty: roky,
    kDatu: datumZDat(data.datum) || o.dnes || new Date(),
  });
}
